import { Serializable } from '@admin/core/models/serializable';

export class RangeFilter<T> implements Serializable<RangeFilter<T>> {
  fromObject(object: any): RangeFilter<T> {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      From: this.from,
      To: this.to,
    };

    return result;
  }

  public from: T;
  public to: T;

  constructor(from: T, to: T) {
    this.from = from;
    this.to = to;
  }
}

export interface RangeFilterModel<T> {
  from?: T;
  to?: T;
}
